import { Pipe, PipeTransform } from '@angular/core';
import { Batch } from '../../models';
import { PRINTED, CLOSED, SEALED_PRINTING, PREPRINT, PRINTING } from '../../../ngrx/status-types';

/**
 * Horizon Filter pipe
 * Takes a list of batches as an argument and filters out related batches to horizon configuration
 * e.g. Batches containing specific horizon_id
 * 
 * Usage: batches | horizonFilter:horizon
 */

@Pipe({
  name: 'horizonFilter'
})
export class HorizonFilterPipe implements PipeTransform {
  transform(batches: Batch[], horizonId) {
    if (!batches || !Array.isArray(batches)) return [];
    if (horizonId && horizonId.id) {
      return batches.filter(batch => batch.horizon_id == horizonId.id);
    }
    return batches;
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/horizon-filter.pipe.ts